/* @flow */
import { Container } from 'flux/utils';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { snooze, wakeup } from 'reducers/connectionStateBanner';
import * as React from 'react';
import Banner from './Banner';
import Glyph from 'components/Glyph';
import Link from 'components/Link';
import ConnectionState from 'stores/ConnectionState';
import PusherActions from 'pusher/PusherActions';

const SNOOZE_MS = 5 * 60 * 1000;

type Props = {
  requestAuthorization: () => void,
  releaseAuthorization: () => void,
  authorized: boolean,

  snoozedAt: ?Date,
  snooze: () => void,
  wakeup: () => void,
};

type State = {
  isConnected: boolean,
  isConnecting: boolean,
  hasRetriedConnection: boolean,
};

export class ConnectionStateBanner extends React.Component<Props, State> {
  // $FlowFixMe initial state from FluxContainer, but need to initialize here for tests
  state = {};
  static getStores() {
    return [ConnectionState];
  }

  static calculateState(): State {
    return {
      isConnected: ConnectionState.isConnected(),
      isConnecting: ConnectionState.isConnecting(),
      hasRetriedConnection: ConnectionState.hasRetriedConnection(),
    };
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const gotSnoozed = !prevProps.snoozedAt && this.props.snoozedAt;
    const gotDisconnected = prevState.isConnected && !this.state.isConnected;
    const gotReconnected = !prevState.isConnected && this.state.isConnected;

    const isSnoozed =
      this.props.snoozedAt && this.props.snoozedAt.getTime() + SNOOZE_MS > new Date().getTime();

    if (gotSnoozed || gotReconnected) {
      this.props.releaseAuthorization();
      return;
    }

    if (gotDisconnected && !isSnoozed) {
      this.props.wakeup();
      this.props.requestAuthorization();
    }
  }

  render() {
    if (!this.props.authorized) {
      return null;
    }

    let message;

    if (this.state.hasRetriedConnection) {
      message = (
        <span>
          Please test your internet connection and{' '}
          <Link onClick={PusherActions.retryConnection}>try again</Link>!
        </span>
      );
    } else if (this.state.isConnecting) {
      message = <span>One second while we try to reconnect…</span>;
    } else {
      message = (
        <span>
          Uh-oh, we’re unable to connect. <Link onClick={PusherActions.retryConnection}>Retry</Link>
          .
        </span>
      );
    }
    return (
      <Banner type="warning" size="normal" onClose={this.props.snooze}>
        <Glyph name="caution" size="large" />
        {message}
      </Banner>
    );
  }
}
function mapStateToProps(state: Object) {
  return {
    snoozedAt: state.connectionStateBanner.snoozedAt,
  };
}
function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ snooze, wakeup }, dispatch);
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  Container.create(ConnectionStateBanner, {
    withProps: true,
  })
);
